import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchDepartmentsSuccess = departments => ({
  type: actions.FETCH_DEPARTMENTS_SUCCESS,
  departments,
});

export const fetchDepartments = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get('/department')
    .then((response) => {
      dispatch(fetchDepartmentsSuccess(response.data));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const fetchDepartmentSuccess = department => ({
  type: actions.FETCH_DEPARTMENT_SUCCESS,
  department,
});

export const fetchDepartment = id => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`/department${id}`)
    .then((response) => {
      dispatch(fetchDepartmentSuccess(response.data));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const createDepartmentSuccess = department => ({
  type: actions.CREATE_DEPARTMENT_SUCCESS,
  department,
});

export const createDepartment = name => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/department', name)
    .then((response) => {
      dispatch(createDepartmentSuccess(response.data));
      dispatch(setLoading(false));
      dispatch(setMessage('Departamento cadastrado com sucesso.'));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const updateDepartmentSuccess = department => ({
  type: actions.UPDATE_DEPARTMENT_SUCCESS,
  department,
});

export const updateDepartment = data => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put('/department', data)
    .then((response) => {
      dispatch(updateDepartmentSuccess(response.data[1][0]));
      dispatch(setLoading(false));
      dispatch(setMessage('Departamento atualizado com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const deleteDepartmentSuccess = id => ({
  type: actions.DELETE_DEPARTMENT_SUCCESS,
  id,
});

export const deleteDepartment = id => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .delete(`/department/${id}`)
    .then(() => {
      dispatch(deleteDepartmentSuccess(id));
      dispatch(setLoading(false));
      dispatch(setMessage('Departamento excluído com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};
